const APP_ENV = process.env.NODE_ENV;

    /** PROD Setup */

const API = 'ore-services/'
// const API = 'sbx-ore-services/'

const BACK_END_ORIGIN = window.location.origin
const BACK_END_PROD =  `${BACK_END_ORIGIN}/${API}`

/** 
 * Dev Setup 
 * MAC Port 8080
 * Win Port 81 
 * */
const BACK_END_DEV = `http://localhost:80/${API}`;
export const BACKEND_URL = (APP_ENV=='development') ? BACK_END_DEV : BACK_END_PROD  ;



// WEBPACK FOOTER //
// ./src/constants/ServiceUrl.js